import { ActivatedRoute, NavigationExtras, Params, Router } from '@angular/router';
import { LocalStorageManager } from '@cloud/main/shared/helpers/local-storage-manager.helper';
import * as _ from 'lodash';

export class SearchParamsHelper {
  static updateQueryParams(router: Router, activatedRoute: ActivatedRoute, searchOptions: Params): void {
    if (_.isUndefined(searchOptions.pageIndex)) {
      searchOptions = { ...searchOptions, pageIndex: 0 };
    }

    if (!_.isUndefined(searchOptions.pageSize)) {
      const pageSizes = { ...LocalStorageManager.pageSizes, [router.url.split('?')[0]]: searchOptions.pageSize };
      LocalStorageManager.pageSizes = pageSizes;
    }

    const navigationExtras: NavigationExtras = {
      relativeTo: activatedRoute,
      queryParams: searchOptions,
      queryParamsHandling: 'merge',
    };
    router.navigate([], navigationExtras);
  }
}
